import { Badge } from "../../shadcn/badge";

export const NewBadge = () => {
    return (
        <Badge
            variant="outline"
            className="
            border-red-500 
            text-red-500
            focus-visible:ring-red-500/40
        "
        >
            New!
        </Badge>
    );
};
